import React from 'react';
import '../styles/Industries.css';

const Industries = () => {
    const industries = [
        {
            id: 'automotive',
            name: 'Automotive',
            icon: '🚗',
            description: 'Comprehensive lubricant solutions for all types of vehicles',
            applications: ['Passenger Cars', 'Motorcycles & Scooters', 'Commercial Vehicles', 'Buses & Trucks'],
            benefits: ['Enhanced engine protection', 'Improved fuel efficiency', 'Extended service intervals', 'Reduced maintenance costs'],
            image: '/logo/engine_oil.jpeg'
        },
        {
            id: 'agriculture',
            name: 'Agriculture',
            icon: '🚜',
            description: 'Specialized lubricants for agricultural machinery and equipment',
            applications: ['Tractors', 'Harvesters', 'Irrigation Systems', 'Farm Equipment'],
            benefits: ['Dust and moisture resistance', 'High load capacity', 'Extended operation in harsh conditions', 'Equipment longevity'],
            image: '/logo/product.jpeg'
        },
        {
            id: 'industrial',
            name: 'Industrial',
            icon: '🏭',
            description: 'Advanced lubricants for industrial machinery and manufacturing',
            applications: ['Manufacturing Equipment', 'Hydraulic Systems', 'Gearboxes', 'Compressors'],
            benefits: ['Extreme pressure protection', 'Thermal stability', 'Corrosion resistance', 'Extended equipment life'],
            image: '/logo/map.jpeg'
        },
        {
            id: 'transportation',
            name: 'Transportation & Logistics',
            icon: '🚛',
            description: 'Reliable lubricants for transportation and logistics operations',
            applications: ['Fleet Management', 'Logistics Centers', 'Warehouse Equipment', 'Material Handling'],
            benefits: ['Fleet efficiency optimization', 'Reduced downtime', 'Cost-effective solutions', '24/7 operation support'],
            image: '/logo/map1.jpeg'
        },
        {
            id: 'construction',
            name: 'Construction',
            icon: '🏗️',
            description: 'Heavy-duty lubricants for construction equipment and machinery',
            applications: ['Excavators', 'Bulldozers', 'Cranes', 'Concrete Equipment'],
            benefits: ['Heavy load protection', 'Dust and debris resistance', 'Extended equipment life', 'Reliable performance'],
            image: '/logo/engine_oil.jpeg'
        },
        {
            id: 'marine',
            name: 'Marine',
            icon: '🚢',
            description: 'Specialized lubricants for marine applications and vessels',
            applications: ['Marine Engines', 'Hydraulic Systems', 'Gearboxes', 'Auxiliary Equipment'],
            benefits: ['Salt water resistance', 'High temperature stability', 'Extended service intervals', 'Environmental compliance'],
            image: '/logo/product.jpeg'
        }
    ];

    const solutions = [
        {
            title: 'Custom Formulations',
            description: 'Tailored lubricant solutions for specific industry requirements',
            icon: '🔬'
        },
        {
            title: 'Technical Support',
            description: 'Expert guidance and application support for optimal performance',
            icon: '🔧'
        },
        {
            title: 'Quality Assurance',
            description: 'Rigorous testing and quality control for consistent performance',
            icon: '🛡️'
        },
        {
            title: 'Training Programs',
            description: 'Comprehensive training for proper lubricant application and maintenance',
            icon: '📚'
        }
    ];

    return (
        <div className="industries">
            {/* Hero Section */}
            <section className="industries-hero">
                <div className="container">
                    <div className="industries-hero-content">
                        <h1>Industries We Serve</h1>
                        <p>Comprehensive lubricant solutions for diverse industrial applications across India</p>
                    </div>
                </div>
            </section>

            {/* Industries Grid */}
            <section className="industries-grid">
                <div className="container">
                    <div className="industries-list">
                        {industries.map((industry, index) => (
                            <div key={index} className="industry-card">
                                <div className="industry-header">
                                    <div className="industry-icon">{industry.icon}</div>
                                    <h2>{industry.name}</h2>
                                </div>
                                <div className="industry-content">
                                    <div className="industry-image">
                                        <img src={industry.image} alt={industry.name} />
                                    </div>
                                    <div className="industry-details">
                                        <p className="industry-description">{industry.description}</p>

                                        <div className="industry-applications">
                                            <h3>Applications</h3>
                                            <ul>
                                                {industry.applications.map((app, idx) => (
                                                    <li key={idx}>{app}</li>
                                                ))}
                                            </ul>
                                        </div>

                                        <div className="industry-benefits">
                                            <h3>Key Benefits</h3>
                                            <ul>
                                                {industry.benefits.map((benefit, idx) => (
                                                    <li key={idx}>{benefit}</li>
                                                ))}
                                            </ul>
                                        </div>

                                        <button className="btn btn-primary">Learn More</button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Solutions Section */}
            <section className="solutions">
                <div className="container">
                    <h2>Our Solutions</h2>
                    <div className="solutions-grid">
                        {solutions.map((solution, index) => (
                            <div key={index} className="solution-card">
                                <div className="solution-icon">{solution.icon}</div>
                                <h3>{solution.title}</h3>
                                <p>{solution.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Case Studies */}
            <section className="case-studies">
                <div className="container">
                    <h2>Success Stories</h2>
                    <div className="case-studies-grid">
                        <div className="case-study">
                            <div className="case-study-header">
                                <h3>Automotive Fleet Optimization</h3>
                                <span className="case-study-category">Transportation</span>
                            </div>
                            <p>A major logistics company reduced their fleet maintenance costs by 25% and extended oil change intervals by 30% using MapLube's premium engine oils.</p>
                            <div className="case-study-stats">
                                <div className="stat">
                                    <span className="stat-number">25%</span>
                                    <span className="stat-label">Cost Reduction</span>
                                </div>
                                <div className="stat">
                                    <span className="stat-number">30%</span>
                                    <span className="stat-label">Extended Intervals</span>
                                </div>
                            </div>
                        </div>

                        <div className="case-study">
                            <div className="case-study-header">
                                <h3>Agricultural Equipment Performance</h3>
                                <span className="case-study-category">Agriculture</span>
                            </div>
                            <p>Farm equipment operators experienced improved performance and reduced breakdowns with MapLube's specialized agricultural lubricants.</p>
                            <div className="case-study-stats">
                                <div className="stat">
                                    <span className="stat-number">40%</span>
                                    <span className="stat-label">Fewer Breakdowns</span>
                                </div>
                                <div className="stat">
                                    <span className="stat-number">20%</span>
                                    <span className="stat-label">Performance Improvement</span>
                                </div>
                            </div>
                        </div>

                        <div className="case-study">
                            <div className="case-study-header">
                                <h3>Industrial Efficiency</h3>
                                <span className="case-study-category">Manufacturing</span>
                            </div>
                            <p>Manufacturing facilities achieved significant energy savings and extended equipment life with our industrial lubricant solutions.</p>
                            <div className="case-study-stats">
                                <div className="stat">
                                    <span className="stat-number">15%</span>
                                    <span className="stat-label">Energy Savings</span>
                                </div>
                                <div className="stat">
                                    <span className="stat-number">35%</span>
                                    <span className="stat-label">Extended Life</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="industries-cta">
                <div className="container">
                    <div className="cta-content">
                        <h2>Ready to Optimize Your Operations?</h2>
                        <p>Contact our industry experts to find the perfect lubricant solution for your specific needs</p>
                        <div className="cta-buttons">
                            <button className="btn btn-primary">Get Consultation</button>
                            <button className="btn btn-secondary">Download Brochure</button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Industries; 